$('.hotspotMap .hotspotMapImg .item').on('click', function (event) {
  const index = $(this).index();
  if (clientWidth <= 960) {
    event.preventDefault();
    $('.hotspotMap .hotspotMapProduct').css('display', 'flex');
    scrollChangeNum({
      ele: '.hotspotMap .hotspotMapProduct .rectangle',
      direction: 'horizontal',
      num: index,
      align: 'center'
    });
  }
})

$('.hotspotMap .hotspotMapProduct').on('click', function () {
  $(this).css('display', 'none');
})

function scrollChangeNum (list = {
  ele, direction: 'horizontal', num: 0, align: 'left'
}) {
  // horizontal: 水平; vertical: 垂直
  // 元素宽度
  var eleSize = list.direction == 'vertical' ? $(list.ele).height() : $(list.ele).width();
  // 元素可活动范围
  var eleScroll = list.direction == 'vertical' ? $(list.ele)[0].scrollHeight : $(list.ele)[0].scrollWidth;
  // 第一个子元素大小
  var elechilrenSize = list.direction == 'vertical' ? $(list.ele).find('>*:first-of-type').outerHeight() : $(list.ele).find('>*:first-of-type').outerWidth();

  const num = $(list.ele).find('>*').length;

  // 子元素间距
  var elechilrenSpace = Math.abs((eleScroll - elechilrenSize * num) / (num - 1));

  var pre = (elechilrenSize + elechilrenSpace) * list.num;

  if (list.align == 'center') {
    pre -= (($(list.ele).outerWidth() - elechilrenSize) / 2);
  }

  if (list.direction == 'vertical') {
    $(list.ele).animate({
      scrollTop: pre
    }, {
      duration: 150,
    });
  } else {
    $(list.ele).animate({
      scrollLeft: pre
    }, {
      duration: 150,
    });
  }
}